import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {MatTableDataSource} from "@angular/material/table";
import {Employee} from "../../../interfaces/Employee";
import {EmployeeService} from "../../../services/employee.service";

import {AddUserRoleComponent, UserRole} from "../../rename/add-user-role/add-user-role.component";
import {LogService} from "../../../services/log.service";
import {AngularFireDatabase} from "@angular/fire/compat/database";
import {CreateEmployee} from "../create-employee/create-employee";
import {EditEmployeeInfoComponent} from "../edit-employee-info/edit-employee-info.component";
import {AngularFireStorage} from "@angular/fire/compat/storage";
import {firstValueFrom, Observable, Subject} from "rxjs";
import {map, takeUntil} from "rxjs/operators";
import {MatSnackBar} from "@angular/material/snack-bar";
import {LoadingService} from "../../../services/loading.service";
import {PermissionType} from "../PermissionType.enum";

@Component({
  selector: 'app-employeelist',
  templateUrl: './employeelist.component.html',
  styleUrls: ['./employeelist.component.scss']
})
export class EmployeelistComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();
  displayedColumns: String[] = ['image','fullName','email','mobile','location','jobtitle' ,'department','status','action' ];
  employeedata!:Employee[];
  data:UserRole[]=[]
  selectedUserName:any;
  selectedDepartments:any;
  UserName$:any
  departments$:Observable<any>
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  dataSource: MatTableDataSource<Employee>
  // permissions = JSON.parse(localStorage.getItem('permissions')!) as UserRole[]
  // employees=this.permissions.filter((x)=>x.functionName=='Counselling')||[]


  constructor(private matdialog: MatDialog,
              private employeeservice:EmployeeService,
              private  readonly matDialog:MatDialog,
              private snackBar : MatSnackBar,
              private readonly mLogService:LogService,
              private isLoading : LoadingService,
              private storage : AngularFireStorage,
              private  readonly mDatabase:AngularFireDatabase
              )
  { // Create 100 users
    const users = Array.from({length: 100} )
    // console.log('Empoyee',this.employees)
    this.departments$ = this.mDatabase.list('types/Employee Departments').valueChanges().pipe(
      map((depts: any[]) => [...depts].sort((a, b) => String(a).trim().localeCompare(String(b).trim())))
    )
    this.dataSource = new MatTableDataSource(this.employeedata)
    console.log(this.dataSource)
  }

  cardColors: any[] = [
    'l-bg-purple-dark',
    'bg-cyan',
    'bg-dark',
    'l-bg-orange',
    'bg-green',
    'l-bg-red',
    'bg-indigo',
    'bg-brown'
  ];
  onImageError(event: Event): void {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = 'assets/images/userbig.png';
  }
  selectedFiles: any;
  async onFileChange(event: any, id: any) {
    console.log(id)
    this.selectedFiles = event.target.files;
    if (this.selectedFiles && this.selectedFiles.length > 0) {
      this.isLoading.setLoading(true); // Start loader
      try {
        const selectedFile = this.selectedFiles[0];
        const filePath = `UserProfileImg/${id}/${selectedFile.name}`;
        const fileRef = this.storage.ref(filePath);
        await fileRef.put(selectedFile);
        const downloadURL = await fileRef.getDownloadURL().toPromise();
        const userData: any = {
          profileImages: downloadURL
        };
        Object.keys(userData).forEach((key) => {
          if (userData[key] === undefined) delete userData[key];
        });
        console.log(id, userData);
        await this.employeeservice.updateUser(id, userData);
        this.snackBar.open(`Image updated successfully!`, 'Close', {
          duration: 3000
        });
      } catch (error) {
        console.error('Error uploading image:', error);
        this.snackBar.open('Error updating image', 'Close', {
          duration: 3000
        });
      } finally {
        this.isLoading.setLoading(false);
      }
    }
  }

  ngOnInit(): void {
    this.addData()
    //Read
    this.employeeservice.getUsers().pipe(takeUntil(this._destroyed$)).subscribe(snapshotchanges=>{
      this.employeedata=[]
      snapshotchanges.forEach(w=>{
        // console.log("payload: ",w)
        let emp = w.payload.toJSON() as Employee
        if (w.key != null) {
          emp['id'] = w.key;
        }
        this.employeedata.push(emp)
      })
      const allNames = this.employeedata.map(emp => emp.userName);
      this.UserName$ = [...new Set(allNames)].sort((a, b) => String(a).trim().localeCompare(String(b).trim())); // removes duplicates, sorted A-Z

      this.dataSource.data =this.employeedata
        this.dataSource.paginator = this.paginator;
      })
  }
  Search() {
    this.dataSource.data = this.employeedata.filter(emp => {
      const matchesUser = this.selectedUserName ? emp.userName === this.selectedUserName : true;
      const matchesDept = this.selectedDepartments ? emp.department === this.selectedDepartments : true;
      return matchesUser && matchesDept;
    });
  }

  clearAll() {
    this.selectedUserName = '';
    this.selectedDepartments = '';
    this.dataSource.data = this.employeedata;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    // if (this.dataSource.paginator) {
    //   this.dataSource.paginator.firstPage();
    // }
  }

  get pagedFilteredData(): any[] {
    if (this.dataSource?.paginator) {
      const start = this.dataSource.paginator.pageIndex * this.dataSource.paginator.pageSize;
      const end = start + this.dataSource.paginator.pageSize;
      return this.dataSource.filteredData.slice(start, end);
    }
    return this.dataSource?.filteredData || [];
  }
  openpopup() {
    this.matdialog.open(CreateEmployee,
      {
        width: '70%', height: '600px',
        enterAnimationDuration: '100ms',
        exitAnimationDuration: '200ms',
      }
    )
  }

  viewDialog(element:any) {

    this.matDialog.open(AddUserRoleComponent,{data:element,
      width:'800%',
      height:'90%'})

  }

  private addData() {
    this.data.push(   {functionName: "Child Admission", all:false,add:false,edit:false, archive:false, view:false, excel:false, showMenu:false })
    this.data.push({functionName: "Child Prescreening",all:false,add:false,edit:false , archive:false, view:false, excel:false, showMenu:false})
    this.data.push({functionName: "Counselling", all:false,add:false,edit:false,  archive:false, view:false, excel:false, showMenu:false})
    this.data.push({functionName: "Education", all:false,add:false,edit:false,  archive:false, view:false, excel:false, showMenu:false})
    this.data.push({functionName: "Meal Mate", all:false,add:false,edit:false,  archive:false, view:false, excel:false, showMenu:false})
    this.data.push({functionName: "Unit Sponsorship", all:false,add:false,edit:false,  archive:false, view:false, excel:false, showMenu:false})
    this.data.push({functionName: "General Donation", all:false,add:false,edit:false,  archive:false, view:false, excel:false, showMenu:false})
    this.data.push({functionName: "CMS", all:false,add:false,edit:false,  archive:false, view:false, excel:false, showMenu:false})
    this.data.push({functionName: "Child Report", all:false,add:false,edit:false,  archive:false, view:false, excel:false, showMenu:false})
    this.data.push({functionName: "Counseling Report", all:false,add:false,edit:false,  archive:false, view:false, excel:false, showMenu:false})
    this.data.push({functionName: "Education Report", all:false,add:false,edit:false,  archive:false, view:false, excel:false, showMenu:false})
    this.data.push({functionName: "Donation Report", all:false,add:false,edit:false,  archive:false, view:false, excel:false, showMenu:false})
    this.data.push({functionName: "Weekly Report", all:false,add:false,edit:false,  archive:false, view:false, excel:false, showMenu:false})
    this.data.push({functionName: "Centres", all:false,add:false,edit:false,  archive:false, view:false, excel:false, showMenu:false})
    this.data.push({functionName: "Employees", all:false,add:false,edit:false,  archive:false, view:false, excel:false, showMenu:false})
    this.data.push({functionName: "Hospital", all:false,add:false,edit:false,  archive:false, view:false, excel:false, showMenu:false})
    this.data.push({functionName: "Unit", all:false,add:false,edit:false,  archive:false, view:false, excel:false, showMenu:false})
    this.data.push({functionName: "Types", all:false,add:false,edit:false,  archive:false, view:false, excel:false, showMenu:false})
    this.data.push({functionName: "Donor", all:false,add:false,edit:false,  archive:false, view:false, excel:false, showMenu:false})
    this.data.push({functionName: "Event", all:false,add:false,edit:false,  archive:false, view:false, excel:false, showMenu:false})
    this.data.push({functionName: "Audit Logs", all:false,add:false,edit:false,  archive:false, view:false, excel:false, showMenu:false})
    this.data.push({functionName: "Dashboard", all:false,add:false,edit:false,  archive:false, view:false, excel:false, showMenu:false})
  }

  editDialog(element:any) {
    this.matDialog.open(EditEmployeeInfoComponent,{data:element,
      width:'800%',
      height:'90%'})

  }

  getStatus(element: any): string {
    return element.disabled === true ? "Inactive" : "Active";
  }

  editImage(element: any) {
    // Open image upload dialog or navigate to image editor
    console.log('Edit image for', element);
  }

  protected readonly PermissionType = PermissionType;

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
